export default "__VITE_ASSET__QsTPSRs8__"